import React, { useState, useMemo } from 'react'
import { SearchBox } from '@tecuity/granite-ui/SearchBox'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { Spinner } from '../../Loaders/Loaders'
import RightArrow from '@tecuity/sos-icons/react/right-arrow'
import Revert from '@tecuity/sos-icons/react/revert'
import '../../WorkviewManager/WorkviewManager.scss'
import * as api from '../../../requests'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'

const defaultQuery = {
  FirstName: '',
  LastName: '',
  Email: '',
}

const LinkedUserSearch = ({ updateAndCloseModal, linkedAccounts, checkConnected }) => {
  const [searchQuery, setSearchQuery] = useState(defaultQuery)
  const [searchResults, setSearchResults] = useState([])
  const [showSearchUserError, setShowSearchUserError] = useState(false)
  const [showSpinner, setShowSpinner] = useState(false)
  const [selectedUsers, setSelectedUsers] = useState(linkedAccounts || [])
  const [hasSearchBeenMade, setHasSearchBeenMade] = useState(false)
  const [isDirty, setIsDirty] = useState(false)

  const searchForUsers = (query = searchQuery) => {
    setHasSearchBeenMade(true)
    setShowSpinner(true)
    setShowSearchUserError(false)
    api.SEARCH_USERS(
      {
        FirstName: query.FirstName || undefined,
        LastName: query.LastName || undefined,
        Email: query.Email || undefined,
        // FrequentPayorFilter: true, // not in UserSearch/search endpoint yet
      },
      (data) => {
        setShowSpinner(false)
        console.log(data)
        // the filter ensures only one payor account per user.
        setSearchResults(
          // .filter((user) => user.PayAccountNum === null)
          data.map((user) => {
            return {
              ...user,
              isUserSelected: !!selectedUsers.find((selected) => selected.UserId === user.UserId),
            }
          })
        )
      },
      (err) => {
        console.error(err)
        setShowSpinner(false)
        setSearchResults([])
      }
    )
  }

  const addUserToAccount = (user) => {
    setIsDirty(true)
    setSelectedUsers((users) => [
      ...users,
      { UserId: user.UserId, Name: `${user.FirstName} ${user.LastName}`, Email: user.Username },
    ])
    setSearchResults((list) =>
      list.map((resultUser) =>
        resultUser.UserId === user.UserId ? { ...resultUser, isUserSelected: true } : resultUser
      )
    )
  }

  const removeUserFromAccount = (user) => {
    setIsDirty(true)
    setSelectedUsers((users) => users.filter((u) => u.UserId !== user.UserId))
    setSearchResults((list) =>
      list.map((resultUser) =>
        resultUser.UserId === user.UserId ? { ...resultUser, isUserSelected: false } : resultUser
      )
    )
  }

  const filteredSearchResults = useMemo(() => {
    return searchResults.filter(
      (user) =>
        !user.isUserSelected &&
        ![-1, 1].includes(user.UserId) &&
        !selectedUsers.find((selected) => selected.UserId === user.UserId)
    )
  }, [searchResults, selectedUsers])

  return (
    <div className="wvm-modal">
      <div className="flex-column-wrapper paper-process-container">
        <div style={{ margin: '5px', padding: '15px' }}>
          <div className="filingSelectButtonWrapper">
            <div className="linked-users-header">Linked User Accounts (click to remove)</div>
            <div elevation="standard" className="search-bar">
              <ContextButton
                variant="secondary"
                disabled={selectedUsers.length === 0}
                leftIcon={
                  <div className="checkmark-wrapper left">
                    <CrossHeavy />
                  </div>
                }
                onClick={() => {
                  setSelectedUsers([])
                  setSearchResults((results) =>
                    results.map((user) => {
                      return {
                        ...user,
                        isUserSelected: false,
                      }
                    })
                  )
                  setIsDirty(true)
                }}
              >
                Clear Users
              </ContextButton>
              <ContextButton
                variant="danger"
                disabled={!isDirty}
                leftIcon={
                  <div className="checkmark-wrapper left">
                    <Revert />
                  </div>
                }
                onClick={() => {
                  setSelectedUsers(linkedAccounts || [])
                  setSearchResults((results) =>
                    results.map((user) => {
                      return {
                        ...user,
                        isUserSelected: false,
                      }
                    })
                  )
                  setIsDirty(false)
                }}
              >
                Revert
              </ContextButton>
              <ContextButton
                variant="primary"
                disabled={!isDirty}
                rightIcon={
                  <div className="checkmark-wrapper right">
                    <RightArrow />
                  </div>
                }
                onClick={() => {
                  updateAndCloseModal(selectedUsers)
                }}
              >
                Update
              </ContextButton>
            </div>
          </div>
          {selectedUsers.length > 0 ? (
            <div className="search-wrapper paper-process-result-wrapper">
              {selectedUsers.map((user, i) => {
                return (
                  <div
                    key={i}
                    className="stacked-data-result paper-process-result-item remove"
                    type="button"
                    onClick={() => {
                      removeUserFromAccount(user)
                    }}
                  >
                    <div className="row">
                      <div className="search-result">
                        <span className="primary">{`${user.Name}`}</span>
                        <span className="secondary">{`Email: ${user.Email}`}</span>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          ) : (
            <div
              style={{
                textAlign: 'center',
                width: '100%',
              }}
            >
              <h1 style={{ padding: '15px', fontWeight: 'bold' }}>{`No User Accounts Linked`}</h1>
            </div>
          )}
          <div className="filingSelectButtonWrapper">
            <SearchBox
              label={'First Name'}
              placeholder={'First Name'}
              value={searchQuery.FirstName || ''}
              onChange={(value) => setSearchQuery((query) => ({ ...query, FirstName: value }))}
              showClearButton={false}
              showSearchButton={false}
              onSubmit={(value) => searchForUsers({ ...searchQuery, FirstName: value })}
            />
            <SearchBox
              label={`Last Name`}
              placeholder={`Last Name`}
              value={searchQuery.LastName || ''}
              onChange={(value) => setSearchQuery((query) => ({ ...query, LastName: value }))}
              showClearButton={false}
              showSearchButton={false}
              onSubmit={(value) => searchForUsers({ ...searchQuery, LastName: value })}
            />
            <SearchBox
              label={`Email`}
              placeholder={`Email`}
              value={searchQuery.Email || ''}
              onChange={(value) => setSearchQuery((query) => ({ ...query, Email: value }))}
              showClearButton={false}
              showSearchButton={false}
              onSubmit={(value) => searchForUsers({ ...searchQuery, Email: value })}
            />
            <div elevation="standard" className="search-bar">
              <ContextButton
                variant="danger"
                onClick={() => {
                  setSearchQuery(defaultQuery)
                  setHasSearchBeenMade(false)
                  setSearchResults([])
                  setShowSearchUserError(false)
                }}
              >
                Clear
              </ContextButton>
              <ContextButton variant="primary" onClick={() => searchForUsers()}>
                Search
              </ContextButton>
            </div>
          </div>
        </div>
        {filteredSearchResults.length === 0 && !showSpinner && (
          <div
            style={{
              textAlign: 'center',
              width: '100%',
            }}
          >
            <h1 style={{ padding: '15px', fontWeight: 'bold' }}>
              {hasSearchBeenMade
                ? `No Records Found - Please Refine Search`
                : `Please Search for Users to Add to this Account`}
            </h1>
          </div>
        )}
        {showSpinner && (
          <div
            style={{
              height: '200px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            className="form-blocks"
          >
            <div>
              <Spinner className="page-loader" themeColor="neutral" />
            </div>
          </div>
        )}
        <div className="search-wrapper paper-process-result-wrapper">
          {filteredSearchResults.length > 0 &&
            !showSpinner &&
            filteredSearchResults.map((user, i) => {
              const isUserConnected =( user.PayAccountNum !== null && checkConnected )
              return (
                <div
                  key={i}
                  className={`stacked-data-result paper-process-result-item ${
                    isUserConnected ? `disabled` : ``
                  }`}
                  type="button"
                  onClick={() => {
                    if (!isUserConnected) {
                      setShowSearchUserError(false)
                      addUserToAccount(user)
                    } else {
                      setShowSearchUserError(true)
                    }
                  }}
                >
                  <div className="row">
                    <div className={`search-result`}>
                      <span className="primary">{`${user.FirstName} ${user.LastName}`}</span>
                      <span className="secondary">{`Email: ${user.Username}`}</span>
                      {isUserConnected && (
                        <span className="secondary">{`Account Number: ${user.PayAccountNum}`}</span>
                      )}
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
        {showSearchUserError && (
          <div
            style={{
              textAlign: 'center',
              width: '100%',
            }}
          >
            <h1
              style={{ padding: '15px', fontWeight: 'bold' }}
            >{`Selected user is already linked to a different Account`}</h1>
          </div>
        )}
      </div>
    </div>
  )
}

export default LinkedUserSearch
